import api from '@/api';

class PropertyStatus {
  static list() {
    return api.get('/properties/statuses');
  }
}

export default PropertyStatus;
